import React, { useEffect, useState } from "react";
import {
    Container,
    Card,
    Table,
    Pagination,
} from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { getGallery, deleteGallery } from "../../store/slices/gallery";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";


export default function Gallery() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const { galleryList = {}, loading } = useSelector((state) => state.gallerylist);

    useEffect(() => {

        dispatch(getGallery({ page, limit }));

    }, [dispatch])


    const rowsPerPage = 20;

    const galleryData = galleryList || [];



    const totalPages = Math.ceil(galleryData.length / rowsPerPage);


    const paginatedUsers = galleryData.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const buildPages = () =>
        Array.from({ length: totalPages }, (_, i) => i + 1);



    const handleDelete = async (id) => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this gallery image?"
        );

        if (!confirmDelete) return;

        try {
            await dispatch(deleteGallery(id)).unwrap();
            await dispatch(getGallery({ page, limit }));

            toast.success("Gallery deleted successfully");
        } catch (error) {
            console.error(error?.message || error, "Error deleting gallery:");
            toast.error("Failed to delete gallery");
        }
    };

    return (
        <>

            <div className="breadcrumb-bar mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Gallery
                            </span>
                        </div>

                        <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/add-gallery")}
                        >

                            Add Image
                        </button>

                    </div>
                </div>
            </div>


            <div className="ud-page-wrap">
                <Container fluid>
                    <div className="ud-header">
                        <h2 className="ud-main-title">Gallery</h2>

                    </div>



                    {loading ? (
                        <Card className="ud-table-card">
                            <Card.Body
                                className="d-flex justify-content-center align-items-center"
                                style={{ minHeight: "300px" }}
                            >
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "4rem",
                                        height: "4rem",
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                            </Card.Body>
                        </Card>
                    ) : (
                        <Card className="ud-table-card">
                            <Card.Body className="p-0">
                                <div className="ud-scroll-wrap">
                                    <Table
                                        hover
                                        borderless
                                        className="ud-table align-middle mb-0"
                                    >
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Title</th>
                                                <th>Image</th>

                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {paginatedUsers.length > 0 ? (
                                                paginatedUsers.map((gallery, index) => (
                                                    <tr key={gallery._id}>
                                                        <td>
                                                            {(page - 1) * rowsPerPage +
                                                                index +
                                                                1}
                                                        </td>

                                                        <td>
                                                            <span className="awd-userid">
                                                                {gallery.title}
                                                            </span>
                                                        </td>

                                                        <td><img src={gallery.image} style={{ width: "80px" }} alt="" /> </td>


                                                        <td>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent:
                                                                        "center",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: "10px",
                                                                }}
                                                            >

                                                                <button
                                                                    onClick={() =>
                                                                        handleDelete(
                                                                            gallery._id
                                                                        )
                                                                    }
                                                                    title="Delete"
                                                                    className="deletebtn"
                                                                >
                                                                    <FaTrash
                                                                        size={12}
                                                                    />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="5"
                                                        className="text-center py-4"
                                                    >
                                                        No gallerys Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    )}


                    <div className="ud-pagination-wrap">
                        <Pagination className="ud-pagination mb-0">
                            <Pagination.Prev
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            />

                            {buildPages().map((p) => (
                                <Pagination.Item
                                    key={p}
                                    active={page === p}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            />
                        </Pagination>
                    </div>
                </Container>
            </div>
        </>
    );
}